/* Store initialization */
export const SET_COOKIE_POLICY = 'SET_COOKIE_POLICY'
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY'
export const SET_PERSONAL_DATA_POLICY = 'SET_PERSONAL_DATA_POLICY'
